module.exports = __webpack_public_path__ + "img/3.27a8d423.png";